<template>
  <div></div>
</template>

<script>
export default {
  async mounted() {
    // espera o logout terminar (ele remove a inscrição de push antes de apagar o token);
    // com o token ainda salvo, a rota de login mandaria de volta para a home
    await this.$services.authService.logout();
    if (this.$route.name !== "login") {
      this.$router.push({ name: "login" });
    }
  },
};
</script>

<style></style>
